import type { ReactNode } from 'react'

import type { ParsedTemplateVariable } from '@/components/organisms/template-variable-editor/template-variable.interface'
import type { TemplateVariableFormValues } from '@/components/organisms/template-variable-form/template-variable-form.interface'
import { TemplateVariableForm } from '@/components/organisms/template-variable-form/template-variable-form.organism'
import { Separator } from '@/components/ui/separator'

interface PromptTemplateFormPreviewProps {
  variableList: ParsedTemplateVariable[]
  onSubmit: (values: TemplateVariableFormValues) => void
  onCancel: () => void
}

/**
 * Preview wrapper that renders the dynamic template variable form
 * with a heading and conditional visibility based on variable presence.
 */
export const PromptTemplateFormPreview: React.FC<PromptTemplateFormPreviewProps> = ({
  variableList,
  onSubmit,
  onCancel,
}): ReactNode => {
  if (variableList.length === 0) return null

  return (
    <div className="prompt-template-form-preview space-y-4">
      <Separator />
      <div>
        <h3 className="text-sm font-medium">Form Preview</h3>
        <p className="text-xs text-muted-foreground">
          Preview of the form users will fill out when using this template
        </p>
      </div>
      <TemplateVariableForm
        variableList={variableList}
        onSubmit={onSubmit}
        onCancel={onCancel}
        submitLabel="Preview Submit"
        cancelLabel="Reset"
      />
    </div>
  )
}

PromptTemplateFormPreview.displayName = 'PromptTemplateFormPreview'
